var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileyVeryHappy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "smiley_very_happy_svg__Plus",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smiley_very_happy_svg__st1{fill:$colour-neutral-grey-900}")), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0",
  style: {
    fill: "#ffdb00"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.9 9.3c.7 0 1.3.5 1.3 1.3h1.3C10.4 9.1 9.3 8 7.9 8s-2.6 1.1-2.6 2.6h1.3c0-.8.6-1.3 1.3-1.3M16.1 9.3c.7 0 1.3.5 1.3 1.3h1.3c0-1.5-1.1-2.6-2.6-2.6-1.4 0-2.6 1.1-2.6 2.6h1.3c.1-.8.6-1.3 1.3-1.3M12 18.6c2.5 0 4.9-1.3 6.3-3.4l-1.1-.7c-1.3 2-3.6 3-5.9 2.8-1.8-.2-3.5-1.2-4.5-2.8l-1.1.7c1.2 1.9 3.2 3.1 5.4 3.4z",
  className: "smiley_very_happy_svg__st1"
})));
export { SvgSmileyVeryHappy as ReactComponent };
export default __webpack_public_path__ + "smiley_very_happy.svg";